"use client";

import { motion } from 'framer-motion';
import { Globe } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/contexts/language-context';

const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguage();

  const toggleLanguage = () => {
    setLanguage(language === 'en' ? 'nl' : 'en');
  };

  return (
    <motion.div
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
    >
      <Button
        variant="ghost"
        size="sm"
        onClick={toggleLanguage}
        className="flex items-center gap-2 text-cream hover:text-cloud-blue hover:bg-cloud-blue/10 transition-all duration-300 px-3 py-2"
      >
        <Globe className="w-4 h-4" />
        <span className="text-sm font-light">
          {language.toUpperCase()}
        </span>
      </Button>
    </motion.div>
  );
};

export default LanguageSwitcher;